module.exports = __webpack_public_path__ + "assets/img/c6987a5e25c1c5edce068754ff4ad812.png";